import Scrollbar from './Scrollbar'

export default {
  name: 'scrollbar',
  configure: function(config) {
    config.addComponent('scrollbar', Scrollbar)
  }
}
